<app-modal-container
  [title]="'Unsaved changes'"
  [titleDirection]="'centered'"
  [innerModal]="isInnerModal"
  [buttons]="modalButtons"
  [bigSize]="false"
  (applyButtonClicked)="close(true)"
  (dismissButtonClicked)="close(false)">
  <label class="font-3">Your changes will not be saved.</label>
</app-modal-container>
